//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import limitsConfig from './configs/limits';
import billsConfig from './configs/bills';

export default {
  props: {
    row: { type: Object, required: true },
  },

  data() {
    return {
      limitsConfig,
      billsConfig,
    };
  },

  computed: {
    getBills() {
      const bills = this.$props.row.cashData;
      return bills.sort((a, b) => b.fiatValue - a.fiatValue);
    },
  },

  methods: {},
};
